module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_null@2x.b1d70fee.png";